import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { PATHS } from "util/appConstants";
import { selectOrder, selectOrderStatus, getOrder, editOrder } from "redux/slices/orderSlice";
import { getCustomers, selectCustomers } from "redux/slices/customerSlice";
import OrderForm from "components/Orders/form";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import { selectUser } from "redux/slices/userSlice";
import { getRoutesForCurrentTours, selectRoutes } from "redux/slices/routeSlice";

const currentAction = "EDIT";

const EditOrder = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const loading = useSelector(selectOrderStatus);
  const order = useSelector(selectOrder);
  const customers = useSelector(selectCustomers);
  const routes = useSelector(selectRoutes);
  const readOnlyAtbasOrder =
    order?.created_via === "import_atbas_scan" &&
    user?.account_permissions?.allow_atbas_order_editing !== true;

  useEffect(() => {
    if (id) {
      dispatch(getOrder(id));
    }
  }, []);

  // TODO: Elegantly handle getting all customers for lager
  useEffect(() => {
    if (!customers.length) {
      if (user?.permissions?.customers?.admin) {
        dispatch(getCustomers(true, { where: { duplicate: false, active: true } }));
      }
      // In case of lager, get all customers as lager can contain inactive/archive customers data as well
      else if (user?.permissions?.orders?.show_warehouse_data) {
        dispatch(
          getCustomers(true, {
            where: {
              supplier_group_id: user?.supplier_group_id,
            },
          })
        );
      } else {
        dispatch(
          getCustomers(true, {
            where: {
              supplier_id: user?.supplier_id,
              duplicate: false,
              active: true,
            },
          })
        );
      }
    }
  }, [dispatch, user]);

  useEffect(() => {
    dispatch(getRoutesForCurrentTours());
  }, [dispatch]);

  const onSubmit = async (payload) => {
    try {
      const res = await dispatch(editOrder(id, payload));
      if (res) {
        const queryParams = new URLSearchParams(history.location.search);
        const routeId = queryParams.get("routeId");
        const fromPage = queryParams.get("fromPage") || "/routes/current";
        const fromReorderModal = queryParams.get("from") === "reorderStopsModal";
        if (fromReorderModal && routeId) {
          history.push(`${fromPage}?openReorderModal=true&routeId=${routeId}`);
        } else {
          history.push(PATHS.orders.root);
        }
      }
    } catch (err) {
    }
  };

  return (
    <>
      <Navbar />
      <LightLayout loading={!order}>
        <OrderForm
          initialValues={order}
          onSubmit={onSubmit}
          action={currentAction}
          customerList={customers}
          routes={routes}
          readOnly={readOnlyAtbasOrder}
        />
      </LightLayout>
    </>
  );
};
export default EditOrder;
